import { formatDatetime, formatDate, cap } from '../utilities/utilities';

const numericTypes = [ 'numeric', 'integer' ]

function stripHtml( strIn ) {
	const str = strIn ? strIn : ''
	return str.replace( /<\/?[^>]+(>|$)/g, " " )
}

const BooleanColumn = props => (
	<td 
		key={ props.rowIndex + '-' + props.columnIndex }
		style={{ whiteSpace:'nowrap', padding:'3px 0 0 0', textAlign:'center' }} 
	 >
		<span 
			className="material-symbols-outlined"
			style={{ 
				cursor:'pointer', padding:0, margin:0, 
				opacity:props.row[ props.column.column_name ] === 't' ? 1 : 0.35 
			}}
		>
			{ props.row[ props.column.column_name ] === 't' ? 'check_box' : 'check_box_outline_blank' }
		</span>
	</td>
)

const TextColumn = props => { 
	const c = props.column
	const row = props.row
	let columnValue = stripHtml( row[ c && c.column_name ] )
	if ( c.data_type === 'date' ) columnValue = formatDate( columnValue )
	//console.log( 'c', c ) 
	return (
		<td 
			key={ props.rowIndex + '-' + props.columnIndex }
			style={{ 
				whiteSpace:'nowrap', padding:'8px 16px', fontWeight:500,
				textAlign:numericTypes.includes( props.column && props.column.data_type ) ? 'right' : 'left',
			}} 
		>
			{ columnValue }
		</td>
	) 
}

export default function Rows( props ) {

	/*
	const align = { 
		'numeric':'right', 
		'integer':'right', 
	}
	*/

	const numericTypes = [ 'numeric', 'integer' ]

	//const hideColumns = [ 'id', 'created', 'modified', 'ordinal', 'admin_user_id', 'password_hash', 'token', 'token_created', 'token_expires', 'cruise_id', 'page_id', 'category_id' ]
	//const hideColumns = [ 'id', 'created', 'modified', 'ordinal', 'admin_user_id', 'password_hash', 'token', 'token_created', 'token_expires', 'cruise_id', 'page_id', 'category_id', 'location_start_geo', 'location_start_zoom', 'location_start_address', 'location_end_geo', 'location_end_zoom', 'location_end_address' ]
	//const hideColumns = [ 'id', 'created', 'modified', 'ordinal', 'admin_user_id', 'password_hash', 'token', 'token_created', 'token_expires', 'cruise_id', 'page_id', 'category_id', 'location_start_geo', 'location_start_zoom', 'location_start_address', 'location_end_geo', 'location_end_zoom', 'location_end_address', 'notes', 'information', 'language' ]
	const hideColumns = [ 'id', 'created', 'modified', 'ordinal', 'admin_user_id', 'password_hash', 'token', 'token_created', 'token_expires', 'cruise_id', 'page_id', 'category_id', 'location_start_geo', 'location_start_zoom', 'location_start_address', 'location_end_geo', 'location_end_zoom', 'location_end_address', 'notes', 'information', 'language', 'location_geo', 'zoom' ]

	return <>
		{ props.rows.map( ( r, j ) => (
			<tr 
				key={ j }
				style={{ cursor:'pointer' }} 
				onClick={ e => props.setRowId( r.id ) }
			>
				{ props.structure.hasOwnProperty( props.table ) && props.structure[ props.table ].map( ( c, i ) => { 
					if ( hideColumns.includes( c.column_name ) ) return false

					return <>
						{ c.data_type === 'boolean' && 
						  <BooleanColumn rowIndex={ j } columnIndex={ i } row={ r } column={ c } /> 
						}
						{ c.data_type !== 'boolean' && 
						  <TextColumn rowIndex={ j } columnIndex={ i } row={ r } column={ c } /> 
						}
					</>

					/*
					if ( c.data_type === 'boolean' ) { 
						return (
							<td key={ j + '-' + i }
								style={{ whiteSpace:'nowrap', padding:'3px 0 0 0', textAlign:'center' }} 
							 >
								<span className="material-symbols-outlined"
									style={{ 
										cursor:'pointer', padding:0, margin:0, 
										opacity:r[ c.column_name ] === 't' ? 1 : 0.35,
									}}
								>
									{ r[ c.column_name ] === 't' ? 'check_box' : 'check_box_outline_blank' }
								</span>
							</td>
							
						) 
					} else {
						return (
							<td key={ j + '-' + i }
								style={{ 
									whiteSpace:'nowrap', padding:'8px 16px', 
									textAlign:numericTypes.includes( c.data_type ) ? 'right' : 'left',
								}} 
							>
								{ r[ c.column_name ] }
							</td>
						)
					}
					*/

				} ) }
			</tr>
		) ) }
	</>
}
